import { render, staticRenderFns } from "./EZUIKitJs.vue?vue&type=template&id=1dd1bfc6"
import script from "./EZUIKitJs.vue?vue&type=script&lang=js"
export * from "./EZUIKitJs.vue?vue&type=script&lang=js"
import style0 from "./EZUIKitJs.vue?vue&type=style&index=0&id=1dd1bfc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports